import { FC } from 'react';

import { Icon } from '@shared/components/icons';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Link } from 'react-router-dom';

const BugoMainLinkList: FC = () => {
  const { ChevronRight, Modify, Register, Phone } = Icon();

  const { isAdmin } = useAuth();

  return (
    <div className="flex flex-col gap-3">
      <Link to="/fevent/add" className="px-3 py-2 pb-4 shadow-smd theme-bg-1">
        <div className="grid w-full grid-cols-auto-1fr-auto items-center justify-between">
          <div className="pl-2 pr-4 ">
            <div className="center-box wh-10 rounded-full theme-bg-18">
              <Register />
            </div>
          </div>
          <p className="bugo-h1 w-full text-start">부고 등록</p>
          <div className="center-box wh-10">
            <ChevronRight />
          </div>
          <div></div>
          <p className="noto-sans-kor text-start text-12 font-normal leading-5 theme-text-8">
            고인 및 상주 정보를 등록해주세요.
          </p>
        </div>
      </Link>
      <Link to="/fevent/manage" className="px-3 py-2 pb-4 shadow-smd theme-bg-1">
        <div className="grid w-full grid-cols-auto-1fr-auto items-center justify-between">
          <div className="pl-2 pr-4">
            <div className="center-box wh-10 rounded-full theme-bg-18">
              <Modify />
            </div>
          </div>
          <p className="bugo-h1 w-full text-start">부고 관리</p>
          <div className="center-box wh-10">
            <ChevronRight />
          </div>
          <div></div>
          <p className="noto-sans-kor text-start text-12 font-normal leading-5 theme-text-8">
            부고 수정 및 삭제를 할 수 있습니다.
          </p>
        </div>
      </Link>
      {isAdmin() && (
        <Link to="/admin/phone-search" className="px-3 py-2 pb-4 shadow-smd theme-bg-1">
          <div className="grid w-full grid-cols-auto-1fr-auto items-center justify-between">
            <div className="pl-5 pr-6">
              <div className="center-box wh-5 rounded-full theme-bg-18">
                <Phone />
              </div>
            </div>
            <p className="bugo-h1 w-full text-start">전화검색</p>
            <div className="center-box wh-10">
              <ChevronRight />
            </div>
            <div></div>
          </div>
        </Link>
      )}
    </div>
  );
};

export default BugoMainLinkList;
